A visual representation of advertisement branding.
